<template>
  <div class="content-page">
    <div class="tab-content" v-loading="isLoading">
      <el-form
        :model="bookingForm"
        :rules="rules"
        ref="bookingForm"
        label-width="98px"
        class="shopsetting-form"
        width="328px"
        :hide-required-asterisk="true"
      >
        <el-form-item label="预约范围">
          客户可预约&nbsp;<el-select
            v-model="bookingForm.beginMinutesRange"
            placeholder="请选择开始时间"
            size="small"
          >
            <el-option
              v-for="(item, index) in beginMinutesRangeList"
              :key="index"
              :label="item.label"
              :value="item.value"
            >
            </el-option> </el-select
          >&nbsp;到&nbsp;<el-select
            v-model="bookingForm.endDayRange"
            placeholder="请选择结束时间"
            size="small"
          >
            <el-option
              v-for="(item, index) in endDayRange"
              :key="index"
              :label="item.label"
              :value="item.value"
            >
            </el-option> </el-select
          >&nbsp;以内的任意时间到店
        </el-form-item>
        <el-form-item label="取消预约">
          <el-radio-group v-model="bookingForm.cancelLimitRadio">
            <el-radio :label="0">客户可随时取消或修改预约单</el-radio>
            <el-radio :label="1"
              >预约到店时间&nbsp;<el-select
                v-model="bookingForm.cancelLimit"
                placeholder="请选择"
                size="small"
              >
                <el-option
                  v-for="(item, index) in cancelLimitList"
                  :key="index"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option> </el-select
              >&nbsp;，客户需联系客服取消或修改预约单</el-radio
            >
          </el-radio-group>
        </el-form-item>
        <el-form-item label="预约次数限制">
          <el-radio-group v-model="bookingForm.appointmentTimeLimitRadio">
            <el-radio :label="0">不限制客户每日预约次数</el-radio>
            <el-radio :label="1"
              >客户每日可预约&nbsp;
              <el-input
                v-model="bookingForm.appointmentTimeLimit"
                placeholder="请填写限制次数"
                type="number"
                size="small"
                :disabled="!bookingForm.appointmentTimeLimitRadio"
                @input.native="numberInputChange"
              ></el-input>
              &nbsp;次</el-radio
            >
          </el-radio-group>
          <p class="tips">达到预约次数限制后，顾客当日无法在线上预约。</p>
        </el-form-item>
        <el-form-item label="预约到店时间"
          >客户添加预约时，以自定义&nbsp;
          <el-select
            v-model="bookingForm.hourStep"
            placeholder="请选择"
            size="small"
          >
            <el-option
              v-for="(item, index) in hourStepList"
              :key="index"
              :label="item.label"
              :value="item.value"
            >
            </el-option> </el-select
          >&nbsp; 小时&nbsp;
          <el-select
            v-model="bookingForm.miniteStep"
            placeholder="请选择"
            size="small"
          >
            <el-option
              v-for="(item, index) in miniteStepList"
              :key="index"
              :label="item.label"
              :value="item.value"
            >
            </el-option> </el-select
          >&nbsp; 分钟 为时间间隔展示
        </el-form-item>
        <el-form-item label="预约量展示">
          <el-radio-group v-model="bookingForm.appointmentNumShow">
            <el-radio :label="1">展示</el-radio>
            <el-radio :label="0">不展示</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="限制数量规则">
          <el-radio-group v-model="bookingForm.numberLimitRule">
            <el-radio :label="0"
              >每段时间可预约&nbsp;
              <el-input
                v-model="bookingForm.numberPerTime"
                placeholder="请填写限制次数"
                type="number"
                size="small"
                @input.native="numberInputChange"
              ></el-input>
              &nbsp;人，推荐客流均匀的门店使用</el-radio
            >
            <el-radio :label="1"
              >每位手艺人在每段时间最多可预约 &nbsp;
              <el-input
                v-model="bookingForm.numberPerTimePerTech"
                placeholder="请填写限制次数"
                type="number"
                size="small"
                @input.native="numberInputChange"
              ></el-input>
              &nbsp;人，推荐客流不均匀的门店使用</el-radio
            >
          </el-radio-group>
          <p class="tips">
            例如：上午客人较少，有 2 位手艺人上班，同一时间可预约 2
            位客户，下午客人较多，有 4 位手艺人上班，同一时间可预约 4 位客户
          </p>
        </el-form-item>
        <el-form-item label="打印纸宽度">
          <el-radio-group v-model="printWidth">
            <el-radio label="58">58mm</el-radio>
            <el-radio label="80">80mm</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item class="submit-btn-container">
          <el-button type="primary" @click="submitForm('bookingForm')"
            >保存</el-button
          >
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import {
  findConfigByShopId,
  saveOrUpdateConfig,
  getShopInfo,
} from "@/api/index.js";
import { mapState, mapActions } from "vuex";
export default {
  data() {
    return {
      bookingForm: {
        beginMinutesRange: 0,
        endDayRange: 15,
        cancelLimitRadio: 0,
        cancelLimit: "",
        appointmentTimeLimitRadio: 0,
        appointmentTimeLimit: 99,
        hourStep: 0,
        miniteStep: 15,
        appointTimeInterval: 15,
        appointmentNumShow: 1,
        numberLimitRule: 0,
        numberPerTime: 10,
        numberPerTimePerTech: 1,
      },
      printWidth: localStorage.getItem("printWidth") || "58",
      rules: {},
      hourStepList: [
        {
          label: "0",
          value: 0,
        },
        {
          label: "1",
          value: 60,
        },
        // {
        //   label: "2",
        //   value: 120,
        // },
        // {
        //   label: "3",
        //   value: 180,
        // },
        // {
        //   label: "4",
        //   value: 240,
        // },
        // {
        //   label: "5",
        //   value: 300,
        // },
        // {
        //   label: "6",
        //   value: 360,
        // },
        // {
        //   label: "7",
        //   value: 420,
        // },
        // {
        //   label: "8",
        //   value: 480,
        // },
        // {
        //   label: "9",
        //   value: 540,
        // },
        // {
        //   label: "10",
        //   value: 600,
        // },
        // {
        //   label: "11",
        //   value: 660,
        // },
        // {
        //   label: "12",
        //   value: 720,
        // },
      ],
      miniteStepList: [
        {
          label: "0",
          value: 0,
        },
        // {
        //   label: "5",
        //   value: 5,
        // },
        // {
        //   label: "10",
        //   value: 10,
        // },
        {
          label: "15",
          value: 15,
        },
        // {
        //   label: "20",
        //   value: 20,
        // },
        // {
        //   label: "25",
        //   value: 25,
        // },
        {
          label: "30",
          value: 30,
        },
        // {
        //   label: "35",
        //   value: 35,
        // },
        // {
        //   label: "40",
        //   value: 40,
        // },
        // {
        //   label: "45",
        //   value: 45,
        // },
        // {
        //   label: "50",
        //   value: 50,
        // },
        // {
        //   label: "55",
        //   value: 55,
        // },
      ],
      cancelLimitList: [
        {
          label: "任意时候",
          value: -1,
        },
        {
          label: "1小时",
          value: 60,
        },
        {
          label: "2小时",
          value: 120,
        },
        {
          label: "6小时",
          value: 360,
        },
        {
          label: "12小时",
          value: 720,
        },
        {
          label: "24小时",
          value: 1440,
        },
        {
          label: "48小时",
          value: 2880,
        },
        {
          label: "7天",
          value: 10080,
        },
      ],
      beginMinutesRangeList: [
        {
          label: "从现在开始",
          value: 0,
        },
        {
          label: "30分钟",
          value: 30,
        },
        {
          label: "1小时",
          value: 60,
        },
        {
          label: "2小时",
          value: 120,
        },
        {
          label: "3小时",
          value: 180,
        },
        {
          label: "4小时",
          value: 240,
        },
        {
          label: "5小时",
          value: 300,
        },
        {
          label: "6小时",
          value: 360,
        },
        {
          label: "7小时",
          value: 420,
        },
        {
          label: "8小时",
          value: 480,
        },
        {
          label: "12小时",
          value: 720,
        },
        {
          label: "24小时",
          value: 1440,
        },
      ],
      endDayRange: [
        {
          label: "7天",
          value: 7,
        },
        {
          label: "15天",
          value: 15,
        },
        {
          label: "1个月",
          value: 30,
        },
        {
          label: "2个月",
          value: 60,
        },
        {
          label: "3个月",
          value: 90,
        },
        {
          label: "6个月",
          value: 180,
        },
        {
          label: "12个月",
          value: 360,
        },
      ],
      isLoading: false,
    };
  },
  watch: {
    "bookingForm.cancelLimitRadio": {
      handler: function(val) {
        if (!this.bookingForm.cancelLimit && val == 1) {
          this.bookingForm.cancelLimit = 60;
        }
      },
    },
    "bookingForm.appointmentTimeLimitRadio": {
      handler: function(val) {
        if (val == 0) {
          this.bookingForm.appointmentTimeLimit = 99;
        }
      },
    },
    printWidth(val) {
      localStorage.printWidth = val;
    },
  },
  computed: {
    ...mapState({
      shop: (state) => state.shopInfo,
    }),
  },
  components: {},
  mounted() {
    this.getPageData();
  },
  methods: {
    ...mapActions(["updateShopInfo"]),
    getPageData() {
      this.isLoading = true;
      findConfigByShopId().then((res) => {
        if (res.code == 1) {
          let timeInterval = res.data.appointTimeInterval / 60;
          if (res.data.endDayRange) {
            let bookingForm = {
              beginMinutesRange: res.data.beginMinutesRange,
              endDayRange: res.data.endDayRange,
              cancelLimitRadio: res.data.cancelLimit ? 1 : 0,
              cancelLimit: res.data.cancelLimit || "",
              appointmentTimeLimitRadio: res.data.appointmentTimeLimit ? 1 : 0,
              appointmentTimeLimit: res.data.appointmentTimeLimit || 99,
              hourStep: parseInt(timeInterval),
              miniteStep: parseInt(
                (timeInterval - parseInt(timeInterval)) * 60
              ),
              appointTimeInterval: res.data.appointTimeInterval,
              appointmentNumShow: res.data.appointmentNumShow,
              numberLimitRule: res.data.numberLimitRule,
              numberPerTime: res.data.numberPerTime,
              numberPerTimePerTech: res.data.numberPerTimePerTech,
            };
            this.bookingForm = bookingForm;
          }
        }
        this.isLoading = false;
      });
    },
    submitForm(formName, cb) {
      console.log(this.bookingForm, "bookingForm");
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let bookingForm = JSON.parse(JSON.stringify(this.bookingForm));
          if (bookingForm.cancelLimitRadio == 0) {
            bookingForm.cancelLimit = 0;
          }
          if (bookingForm.appointmentTimeLimitRadio == 0) {
            bookingForm.appointmentTimeLimit = 0;
          }
          bookingForm.appointTimeInterval =
            bookingForm.hourStep + bookingForm.miniteStep;
          saveOrUpdateConfig(bookingForm).then((res) => {
            if (res.code == 1) {
              this.$notify({
                title: "提示",
                message: "保存成功",
                type: "success",
                duration: 2000,
              });
            } else {
              this.$notify({
                title: "提示",
                message: res.msg,
                type: "warning",
                duration: 2000,
              });
            }
          });
        } else {
          this.$notify({
            title: "提示",
            message: "表单未完善，请检查店铺设置",
            type: "error",
            duration: 2000,
          });
          return false;
        }
      });
    },
    linkTo(path) {
      this.$router.push({
        path: path,
      });
    },
    windowOpen(url) {
      location.href = url;
    },
    numberInputChange(e) {
      e.target.value = e.target.value.replace(/[^\d.]/g, "");
      if (!e.target.value || e.target.value == 0) {
        e.target.value = 1;
      }
    },
  },
};
</script>

<style lang="less" scoped>
.content-page {
  .tab-header {
    padding: 12px 20px;
  }
  .tab-content {
    padding: 40px 48px;
  }
  .el-select {
    width: 120px;
  }
  .el-input {
    width: 100px;
  }
  .shopsetting-form {
    width: 100%;
    .qrcode-img {
      display: inline-block;
      position: relative;
      left: 0px;
      bottom: 0px;
      width: 300px;
      height: 450px;
      margin-right: 10px;
      .bg {
        width: 100%;
        height: 100%;
      }
      .logo {
        position: absolute;
        width: 30px;
        height: 30px;
        right: 136px;
        left: 140.5px;
        top: 243px;
        border-radius: 4px;
      }
      .name {
        position: absolute;
        display: block;
        width: 172px;
        color: #d07910;
        font-size: 10.8px;
        bottom: 64px;
        left: 72px;
        text-align: center;
      }
      .phone {
        display: block;
        width: 100%;
        position: absolute;
        color: #d54538;
        font-size: 12px;
        bottom: 35px;
        left: 0;
        text-align: center;
        font-weight: bold;
      }
      .addresss {
        display: block;
        width: 100%;
        position: absolute;
        color: #d54538;
        font-size: 12px;
        bottom: 17px;
        left: 0;
        text-align: center;
        transform: scale(0.6);
        white-space: nowrap;
        overflow: hidden;
      }
      .info {
        display: block;
        width: 100%;
        position: absolute;
        color: #d54538;
        font-size: 12px;
        bottom: -1px;
        left: 0;
        text-align: center;
        transform: scale(0.6);
      }
      .scan-code-img {
        position: absolute;
        display: block;
        bottom: 147px;
        left: 111px;
      }
    }
    .el-form-item__content {
      .taxnum-input {
        width: 200px;
        margin-right: 10px;
      }
      .el-date-editor {
        width: 182px;
        margin-right: 14px;
      }
      .func-container {
        width: 144px;
        display: inline-block;
        height: 20px;
        line-height: 20px;
        margin-right: 20px;
      }
      .tips {
        font-size: 12px;
        line-height: 14px;
        color: #f56c6c;
        margin-left: 10px;
        & > i {
          margin-right: 6px;
        }
        .el-link {
          font-size: 14px;
          vertical-align: baseline;
          margin-left: 10px;
        }
      }
      .verified-status {
        margin-right: 18px;
      }
    }
    .submit-btn-container {
      margin: 40px 0 200px 0;
    }
    .inline-title {
      line-height: 40px;
      font-size: 14px;
      color: #333333;
      padding-left: 20px;
      background: #f8f8f8;
      margin: 45px 0 24px 0;
    }
    .el-radio {
      display: block;
      line-height: 40px;
    }
    .delivery-template {
      .item {
        margin-bottom: 8px;
        .button-del {
          margin-left: 10px;
          display: none;
        }
        &:hover {
          .button-del {
            display: inline-block;
          }
        }
      }
    }
  }
}
.map {
  width: 100%;
  height: 400px;
  　　/deep/ .anchorBL {
    display: none;
  }
}
</style>
<style lang="less">
.banner-image {
  .el-upload-list--picture-card .el-upload-list__item {
    width: 443px;
    height: 148px;
  }
}
</style>
